import { motion } from 'framer-motion';
import { BsFilePdf } from 'react-icons/bs';
import CompactToolCard from '../components/CompactToolCard';
import SEO from '../components/SEO';
import { pdfToolsSchemas } from '../schemas';
import './PDFTools.css';

const PDFTools = () => {
  const pdfTools = [
    { title: 'Merge PDF', fromFormat: 'PDF', toFormat: 'PDF', customLink: '/pdf-merge' },
    { title: 'Split PDF', fromFormat: 'PDF', toFormat: 'PDF', customLink: '/pdf-split' },
    { title: 'PDF to Images', fromFormat: 'PDF', toFormat: 'PNG', customLink: '/pdf-to-images' },
    { title: 'Add Watermark', fromFormat: 'PDF', toFormat: 'PDF', customLink: '/pdf-watermark' },
    { title: 'Organize Pages', fromFormat: 'PDF', toFormat: 'PDF', customLink: '/pdf-organize' },
    { title: 'Compress PDF', fromFormat: 'PDF', toFormat: 'PDF', customLink: '/compress-pdf' },
    { title: 'Text to PDF', fromFormat: 'TXT', toFormat: 'PDF', customLink: '/text-to-pdf' }
  ];

  return (
    <div className="pdf-tools-page">
      <SEO 
        title="Free PDF Tools Online – Merge, Compress, Split PDF"
        description="Merge, split, compress, convert & organize PDF files free online. Secure, fast PDF tools that work directly in your browser."
        keywords="pdf tools online, free pdf editor, merge pdf, compress pdf"
        path="/pdf-tools"
        schema={pdfToolsSchemas}
      />
      <section className="pdf-tools-hero">
        <div className="hero-container">
          <motion.div 
            className="tool-icon-large"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
          >
            <BsFilePdf />
          </motion.div>

          <motion.h1
            className="page-title"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            PDF Tools
          </motion.h1>

          <motion.p
            className="page-description"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Powerful PDF tools to merge, split, compress, and organize your documents
          </motion.p>
        </div>
      </section>

      <section className="pdf-tools-section">
        <div className="section-container">
          <div className="compact-tools-grid">
            {pdfTools.map((tool, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <CompactToolCard {...tool} />
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default PDFTools;
